import { ResponseError } from "@nimble/react-requests/api-clients/fetch-config";

function isErrorDataObject(data: unknown): data is Record<string, unknown> {
  return data !== null && typeof data === "object" && data !== undefined;
}

export function isRetryCountdownActive(
  retryCountdownSeconds: number | null,
): boolean {
  return retryCountdownSeconds !== null && retryCountdownSeconds > 0;
}

export class OTPThrottleError extends Error {
  retryAfterSeconds: number;

  constructor(message: string, retryAfterSeconds: number) {
    super(message);
    this.name = "OTPThrottleError";
    this.retryAfterSeconds = retryAfterSeconds;
  }

  static fromResponseError(error: ResponseError): OTPThrottleError | null {
    let retryAfter: number | null = null;

    if (isErrorDataObject(error.data)) {
      if (
        "retry_after" in error.data &&
        typeof error.data.retry_after === "number"
      ) {
        retryAfter = error.data.retry_after;
      }
    }

    // Check for Retry-After header (takes precedence)
    const retryAfterHeader = error.headers.get("Retry-After");
    if (retryAfterHeader) {
      const parsed = Number(retryAfterHeader);
      if (!isNaN(parsed) && parsed > 0) {
        retryAfter = parsed;
      }
    }

    if (retryAfter === null) {
      return null;
    }

    let message = "Too many requests. Please wait before trying again.";
    if (
      isErrorDataObject(error.data) &&
      "error" in error.data &&
      typeof error.data.error === "string"
    ) {
      message = error.data.error;
    }

    return new OTPThrottleError(message, Math.max(1, Math.ceil(retryAfter)));
  }
}
